<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/custom/litenghui/label/detail/page" getKey="rows" :columns="columns">
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline"> </el-form>
      </template>
      <template #caozuo="scope">
        <el-button type="text" size="mini" @click="yt.remove(scope.row, '/custom/litenghui/label/detail/delete')" v-if="reportData.status === 1 && utils.checkPower('web_production_management_production_label_delete_lth')">{{ $t('删除') }}</el-button>
      </template>
    </yi_curd_table>
  </div>
</template>

<script>
export default {
  name: 'LabelDetails',
  props: {
    reportData: {
      type: Object,
      required: true
    },
    detailData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      columns: [
        {
          label: 'biaoqqiantiaoma',
          prop: 'printRecord.labelBarcodeNumber',
          width: 150
        },
        {
          label: 'yewuleixing',
          prop: 'printRecord.businessType',
          type: 'dictionary',
          key: 'BUSINESS_TYPE',
          width: 150
        },
        {
          label: 'dayinren',
          prop: 'printByObject.nickname',
          width: 150
        },
        {
          label: 'dayinshijian',
          prop: 'printRecord.createTime',
          type: 'time',
          width: 180
        },
        {
          label: 'shengchangongdanhao',
          prop: 'woNo',
          width: 150
        },
        {
          label: 'ERPgongdanhao',
          prop: 'erpNo',
          width: 150
        },

        {
          label: 'baozhuangshuliang',
          prop: 'printRecord.packageNumber',
          width: 150
        },
        {
          label: 'biaoqianzongshu',
          prop: 'printRecord.labelTotalNumber',
          width: 150
        },
        {
          label: 'dangqianshunxu',
          prop: 'printRecord.currentOrder',
          width: 150
        },
        {
          label: 'picihao',
          prop: 'printRecord.batchNo',
          width: 150
        },
        {
          label: 'yibaogongliangpinshu',
          prop: 'goodQuantity',
          width: 150
        },
        {
          label: 'shengchanzhuangtai',
          prop: 'printRecord.productionStatus',
          type: 'dictionary_tag',
          key: 'LABEL_PRODUCTION_STATUS'
        },
        {
          label: 'zhijianzhuangtai',
          prop: 'printRecord.qualityCheckStatus',
          type: 'dictionary_tag',
          key: 'LABEL_QUALITY_CHECK_STATUS'
        },
        {
          label: 'rukuzhuangtai',
          prop: 'printRecord.storageStatus',
          type: 'dictionary_tag',
          key: 'LABEL_STORAGE_STATUS'
        },
        {
          label: 'youxiaozhuangtai',
          prop: 'printRecord.validStatus',
          type: 'dictionary_tag',
          key: 'LABEL_VALID_STATUS'
        },

        {
          label: 'caozuo',
          type: 'slot',
          width: 150,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions.detailId = this.detailData.id;
      this.yt.get(1);
    }, 300);
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.dialog-scroller {
  max-height: 600px;
  overflow-y: auto;
}

.el-table {
  margin: 20px;
  border-radius: 4px;

  ::v-deep .el-table__header-wrapper {
    th {
      background-color: #f5f7fa;
      color: #606266;
      font-weight: 500;
      padding: 12px 0;
    }
  }

  ::v-deep .el-table__body-wrapper {
    td {
      padding: 12px 0;
    }
  }
}
</style>
